<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
			
			<Button type="primary" @click="wancheng" v-show="macDetails.macDetailsName=='LRZ'">录入完成</Button>
		</div>
		<div class="content"  v-show="macDetails.macDetailsName=='LRZ'">
			<Row>
				<Col>
				<p style="color: #C0C0C0;">操作说明：请先输入设备货道的列数机行数，点击生成货道信息，货道信息无误后，在进行提交</p>
				<p style="color: #C0C0C0;">编号说明：1-1表示第一行第一列的货道</p>
				</Col>
			</Row>
			<Form ref="formValidate" :label-width="80">
				<Row>
					<Col>
					<Alert type="success" v-if="total!=0">货道生成成功，共生成{{total}}个</Alert>
					</Col>
				</Row>
				<h2>自动生成货道：</h2>
				<Row>
					<Col span="6">
					<FormItem label="货道行数" prop="row" class="">
						<Input v-model="row" placeholder="请输入行数" type="number"></Input>
					</FormItem>
					</Col>
					<Col span="6">
					<FormItem label="货道列数" prop="columns" class="">
						<Input v-model="columns" placeholder="请输入货道列数" type="number"></Input>
					</FormItem>
					</Col>
					<Col span="6">
					<FormItem label="最大商品数" prop="columns" class="">
						<Input v-model="maxNumber" placeholder="请输入最大商品数" type="number" ></Input>
					</FormItem>
					</Col>
					<Col span="3">
					<Button type="primary" @click="sc">生成货道</Button>
					</Col>
					
					<Col span="3">
					<Button type="primary" @click="add" v-show="macAisle.length>0">提交</Button>
					</Col>
					
				</Row>
			</Form>

		</div>
		<div class="huodao">
			<div class="item-1" v-for="(item,i) in macAisle" :key="i">
				<div class="item-2" v-for="(aisle,j) in item.b" :key="j">
					 <Tag closable  color="success"  @on-close="deleteAisle(aisle)">{{aisle.number}}</Tag>
				</div>
				<div>
					<Button type="info" @click="addAiske(item.b[0].number1)" v-show="item.b.length>0">新增</Button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import http from '@/http/http.js'
	export default {
		data() {
			return {
				loading:false,
				macDetails:{},
				t:true,
				row: '', //行数
				columns: '', //列数
				maxNumber: 6, //最大商品数
				remark: '', //备注
				total: 0,
				macAisle: [],
				macId:'',
				aisle1: {
					number: '',
					number1: '',
					number2: '',
					remark: '',
					maxNumber: 6,
					sortNumber:''
				},
				manualAddState:0

			}
		},
		methods: {
			ret() { //返回上一页
				this.$router.go(-1)
			},
			add() { //提交信息
			    let d=[]
			    for (let i = 0; i < this.macAisle.length; i++) {
					let bb=this.macAisle[i]
			    	for (let j = 0; j < bb.b.length; j++) {
			    		let cc=bb.b[j]
						d.push(cc)
			    	}
			    }
				if (this.macAisle.length > 0) {
					this.t=false
					let _this=this
					http.http({
					    //这里是你自己的请求方式、url和data参数
					    method: 'post',
					    url: http.url + '/fac/mac/aisle/add',
					    data: {list:d,macId:_this.macId},
						_this: _this,
						success: function(data) {
							
								_this.$Message.success('新增成功!');
						}
					    //假设后台需要的是表单数据这里你就可以更改
					  })
				
				}else{
					this.$Message.error('请完善信息后再进行提交!');
				}
			},
			handleReset() {
				this.maxNumber = '';
				this.row = '';
				this.columns = ''

			},
			sc() { //生成货道信息
				if(this.row<=0 && this.columns<=0 ){
					this.$Message.error('请输入正确的行列数!');
					return ;
				}
				if(this.maxNumber<=0){
					this.$Message.error('请输入最大商品数!');
					return ;
				}
				this.macAisle = []
				let m=1;
				for (var i = 1; i <= this.row; i++) {
					let a=[]
					for (var j = 1; j <= this.columns; j++) {
						a.push({
							sortNumber:m,
							number: i + '-' + j,
							number1: i ,
							number2: j ,
							remark: this.remark,
							maxNumber: this.maxNumber
						})
						m++
					}
					let b={
						b:a
					}
					this.macAisle.push(b)
				}
					console.log(this.macAisle)
				this.total = m
			},
			
			addAiske(i){
				console.log(i)
				let m=this.macAisle[i-1].b[this.macAisle[i-1].b.length-1]
				let number=parseInt(m.number2)+1
				console.log(m)
				let a={
							sortNumber:m.sortNumber+1,
							number: i + '-' + number,
							number1: i ,
							number2: m.number2+1 ,
							remark: this.remark,
							maxNumber: this.maxNumber
						}
				this.macAisle[i-1].b.push(a)
			},
			deleteAisle(aisle) { //删除货道信息
				this.macAisle[aisle.number1-1].b.splice(this.macAisle[aisle.number1-1].b.length-1,1)
			},
			wancheng(){
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				   url: http.url + '/fac/mac/details/updateState',
				   data: {
				   	id: _this.macId,
				   	macDetailsState: "WC"
				   },
					_this: _this.macId,
					success: function(data) {
						
						_this.$Message.success('修改成功!');
						_this.get()
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			},
			get(){
				this.loading=true
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fac/mac/details/get',
				    data: {
						id:_this.macId
					},
					_this: _this,
					success: function(data) {
						_this.macDetails=data.macDetails
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			},
			ajaxPage() {
				this.loading = true
				let _this = this
				http.http({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: http.url + '/fac/mac/aisle/page1',
					data: {
						macId:_this.macId,
						page:0,
						size:100
					},
					_this: _this,
					success: function(data) {
						_this.macAisle = data.macAisles
						_this.loading = false
						console.log(_this.macAisle)
					}
					//假设后台需要的是表单数据这里你就可以更改
				})
			
			},
		},
		created() {
			let _this=this
			_this.macId=_this.$route.query.id
			_this.ajaxPage()
			_this.get()
		}
	}
</script>

<style scoped="scoped" lang="less">
	.ivu-tag{
	}

	.list-btn {
		margin-bottom: 20px;
	}

	.content {
		max-width: 1200px;

	}

	.ivu-form-item {
		margin-bottom: 5px;
	}

	.ivu-row {
		/* margin-bottom: 20px; */
	}
	.huodao{
		 .item-1{
		 	
		 		display: flex;
				align-items: center;
				flex-wrap: wrap;
				.item-2{
					display: flex;
					align-items: center;
				   height: 40px;
				}
		 }
		
	}
	
</style>



// WEBPACK FOOTER //
// src/components/jm/pcoduction/aisle/add.vue